










import { Component, Vue, Emit, Prop } from 'vue-property-decorator'

@Component
export default class Textarea extends Vue {
  @Prop() value!: string
  @Prop() placeholder?: string
  @Prop() rows!: number
  @Prop() cols!: number

  @Emit() input(value: string) { value }
}
